import { getAwsDomainUrl } from '../../../utils/generateURL';
import { IWTButton } from '../IWTButton';

export const ManageCommunicationPreferenceIWT = () => {
  const commPrefLink = `${getAwsDomainUrl(window.location.hostname)}/enterprise/forms/#/commpref`;
  
  return (
    <IWTButton
      title="Manage communication preference"
      id="ManageCommunicationPreferenceIWT"
      onClick={() => {
        window.location.assign(commPrefLink);
      }}
    />
  );
};
